import Tr from 'translations/Translations';

export const ContractorCompanySize = {
    MICRO: "MICRO",
    SMALL: "SMALL",
    MEDIUM: "MEDIUM",
    SELFTRADER: "SELFTRADER",
    NONBUSINESSINDIVIDUAL: "NONBUSINESSINDIVIDUAL",
    OTHERSIZE: "OTHERSIZE",
    LARGE: "LARGE",
    IGNORE: "IGNORE",
}

const _TR_PREFIX = 'contractor_company_size_';
export const ContractorCompanySizeLabel = (size) => (Tr(_TR_PREFIX + size.toLowerCase()));
